import type { Column } from "@tanstack/react-table";
import { ArrowDownIcon, ArrowUpIcon } from "lucide-react";

interface SortIndicatorProps<TData> {
  column: Column<TData, unknown>;
}

export const SortIndicator = <TData,>({
  column,
}: SortIndicatorProps<TData>) => {
  if (!column.getCanSort()) return null;

  const sorted = column.getIsSorted();

  if (sorted === "asc") return <ArrowUpIcon className="ml-1 inline size-4" />;
  if (sorted === "desc")
    return <ArrowDownIcon className="ml-1 inline size-4" />;

  return null;
};
